import xss from 'xss';
// Package: https://www.npmjs.com/package/sanitize-html
// not typed no plan for it to be :(
const whiteList = (allowed_style: boolean) => ({
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  b: [],
  i: [],
  em: [],
  strong: [],
  div: [],
  table: [],
  tbody: [],
  td: [],
  tfoot: [],
  th: [],
  thead: [],
  tr: [],
  span: [allowed_style ? 'style' : ''],
  hr: [],
  li: [],
  ul: [],
  ol: [],
  p: [],
  br: [],
  sup: [],
  img: ['src', 'alt'],
  a: [],
});
// Helper function to escape HTML entities in plain text content
const escapeHtmlEntities = (text: string): string => {
  // Only escape if the text doesn't already contain HTML tags
  // This prevents double-escaping of legitimate HTML content
  if (/<[^>]+>/.test(text)) {
    return text; // Already contains HTML, don't escape
  }

  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
};

export const sanitizeNote = (dirty: string, allowed_style: boolean = false): any => ({
  __html: xss(escapeHtmlEntities(dirty), {
    whiteList: whiteList(allowed_style),
    stripIgnoreTag: true,
  }).trim(),
});
